import { IBase64 } from "@components/general/form/FileInput";
import { FieldType, Model, Schema } from "@core/index";
import { IComment } from "./Comment";
import { IMember } from "./Member";
import { IParticipate } from "./Participate";

export interface IFeedback extends IParticipate {
    participation?: IParticipate;
    referenceId?: string;
    typeId?: number;
    categoryId?: number;
    description?: string;
    status?: FeedBackStatus;
    assignee?: IMember;
    attachments?: IBase64[];
    comments?: IComment[];
    created?: number;
    updated?: number;
}

export enum FeedBackStatus {
    ToDo,
    InProgress,
    Closed
}

export class Feedback extends Model implements IFeedback {
    public static schema: Schema = new Schema("Feedback");
    public typeId?: number;
    public referenceId?: string;
    public categoryId?: number;
    public description?: string;
    public attachments?: IBase64[];

    constructor(values: IFeedback) {
        super(Feedback.schema);
        this.setValues(values);
    }
}

Feedback.schema.addField("referenceId").type(FieldType.String);
Feedback.schema.addField("typeId").type(FieldType.Number).required();
Feedback.schema.addField("categoryId").type(FieldType.Number).required();
Feedback.schema.addField("description").type(FieldType.String).required();
Feedback.schema.addField("attachments").type(FieldType.List);
Feedback.schema.freeze();